import { render, staticRenderFns } from "./modalEditUser.vue?vue&type=template&id=268636d4&"
import script from "./modalEditUser.vue?vue&type=script&lang=ts&"
export * from "./modalEditUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports